import { date } from './date';
import { accountNumber } from './accountNumber';
import { TextMaskModel } from './model.interface';
import { polishPostalCode } from './postCode';
import { workshopCert, technicCert } from './certificate';

export const MaskConfig: TextMaskModel = {
  date: date,
  accountNumber: accountNumber,
  postCode: polishPostalCode,
  workshopCertificate: workshopCert,
  technicCertificate: technicCert,
};
